import gql from 'graphql-tag';

export default gql`
  query CascadeOption($name: String) {
    cascadeOption(name: $name) {
      value
    }
  }
`;
